module.exports = __webpack_public_path__ + "img/PosIcon.76a1e38c.png";